<template>
  <v-container fluid pa-1>
    <v-row :dense="!isDesktopView">
      <v-col
        v-if="cancelable"
        :class="{ 'text-left': isDesktopView }"
        cols="12"
        sm="auto"
      >
        <slot name="controls-cancel" :cancel="cancel">
          <bm-btn
            button-type="secondary"
            :block="!isDesktopView"
            data-qa="dialog_cancel"
            :x-large="large"
            @click="cancel"
          >
            <slot name="controls-cancel-text">
              {{ $m.cancel }}
            </slot>
          </bm-btn>
        </slot>
      </v-col>
      <v-spacer />
      <v-col
        :cols="cancelable && isDesktopView ? 'auto' : 12"
        :sm="cancelable ? 'auto' : 12"
        :class="{ 'text-right': isDesktopView }"
        :order="isDesktopView ? undefined : 'first'"
      >
        <slot
          name="controls-confirm"
          :valid="valid"
          :dirty="dirty"
          :accept="accept"
          :is-desktop-view="isDesktopView"
        >
          <bm-btn
            :button-type="dialogType.confirmButtonClass"
            :disabled="!valid || !dirty"
            :block="!isDesktopView"
            data-qa="dialog_accept"
            :x-large="large"
            @click="accept"
          >
            <slot name="controls-confirm-text">
              {{ $m.save }}
            </slot>
          </bm-btn>
        </slot>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { computed, defineComponent } from "vue";
import { EnumDialogType } from "@/components/dialogs/DialogTypes";
import { useVuetify } from "@/plugins/vuetify";

/**
 * Generic BmDialogControls component
 *
 * @slots
 * 'controls-confirm', to replace only the confirm button
 * 'controls-confirm-text', to replace only the confirm button text
 * 'controls-cancel', 'controls-cancel-text', mimic the above respectively
 *
 * @events
 * 'cancel', normally used to close the menu
 * 'accept', confirm/submit the contents of the dialog
 */

export default defineComponent({
  name: "BmDialogControls",
  props: {
    accept: {
      type: Function,
      required: true,
    },
    cancel: {
      type: Function,
      required: true,
    },
    valid: {
      type: Boolean,
      required: false,
      default: true,
    },
    dirty: {
      type: Boolean,
      required: false,
      default: true, // Default to true for dialogs non-reliant on dirty status
    },
    cancelable: {
      type: Boolean,
      required: false,
      default: true,
    },
    dialogType: {
      type: Object as PropType<EnumDialogType>,
      required: false,
      default: () => EnumDialogType.info,
    },
    large: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props, context) {
    const { $vuetify } = useVuetify();
    const isDesktopView = computed(() => $vuetify.breakpoint.smAndUp ?? true);

    return {
      isDesktopView,
    };
  },
});
</script>
